import { FormControlComponent } from '../form-control.component';
import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'wncm-form-control-password',
	templateUrl: './form-control-password.component.html',
	styleUrls: ['../form-control.component.scss', './form-control-password.component.scss']
})
export class FormControlPasswordComponent extends FormControlComponent {
	isPlain = false;

	@Input()
	appearance = 'outline';

	constructor() {
		super();
	}
}
